import { extendTheme } from "@chakra-ui/react";

// File JS esterno generato per devinire in maniera accentrata le proprietà delle icone.
// Side Effect: anche altre icone al di fuori degli Action Button sono state impattate nella modifica
// Con size:"22px" le icone non accusano problemi.

const actionIconsTheme = extendTheme({
    components: {
        Icon: {
            baseStyle: {
                boxSize: "22px",
                _hover: { color: "#0888BE" }
            },
        },
    },
});

export default actionIconsTheme;